import { useForm } from "react-hook-form";
import { FormInput } from "../../shared/formElements/formInput/FormInput";
import { FormCheckboxChips } from "../../shared/formElements/formCheckBoxChip/FormCheckBoxChip";
import { formatDate } from "../../../utils/formatNumber";
import { FormTextarea } from "../../shared/formElements/formTextarea/FormTextarea";
import classes from "./refundDetailForm.module.css";

const RefundStatus = [
  { id: 15, label: "Approve" },
  { id: 21, label: "Reject" },
];

export const RefundDetailForm = ({ initialValues, onSubmit, isSubmitting }) => {
  const { register, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      order_status: initialValues.order_status ?? "",
      remarks: initialValues.remarks ?? "",
    },
  });

  // current selection
  const orderStatus = watch("order_status");

  const remarks = (watch("remarks") || "").trim();

  // disable whole status update if already processed
  const isDisabled = initialValues.status !== "Refund Requested";
  const isRejected = String(orderStatus) === "21";
  // enable remarks ONLY when REJECT is selected
  const isRemarksEnabled = isRejected && !isDisabled;

  const disableSubmit = isSubmitting || !orderStatus || isDisabled;

  console.log("remarks", remarks)

  const handleFormSubmit = (data) => {
    const payload = {
      order_id: initialValues.id,
      order_status: Number(data.order_status),

      ...(data.remarks?.trim() ? { remarks: data.remarks.trim() } : {}),
    };

    onSubmit(payload);
    
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(handleFormSubmit)}>
      <div className={classes.columnsWrapper}>
        <div className={classes.section}>
          <div className={classes.grid}>
            <FormInput label="Refund ID" value={initialValues.id} readOnly />
            <FormInput
              label="Order ID"
              value={initialValues.order_id}
              readOnly
            />

            <FormInput
              label="Delivered On"
              value={formatDate(initialValues.delivered_on)}
              readOnly
            />

            <FormInput
              label="Postal Code"
              value={initialValues.postal_code}
              readOnly
            />

            <FormInput
              label="Total Amount"
              value={initialValues.price}
              readOnly
            />

            <FormCheckboxChips
              id="order_status"
              label="Status"
              options={RefundStatus}
              watch={watch}
              setValue={setValue}
              register={register}
              disabled={isDisabled}
            />
          </div>
          <div className={classes.grid}>
            <FormTextarea
              id="reason"
              label="Reason"
              value={initialValues.reason}
              disabled
            />

            <FormTextarea
              id="remarks"
              label="Remarks For Rejection"
              placeholder="Add remarks for rejection"
              register={register}
              disabled={!isRemarksEnabled || isDisabled}
            />
          </div>
        </div>
      </div>

      <div className={classes.actions}>
        <button
          type="submit"
          className={classes.submitBtn}
          disabled={disableSubmit}
        >
          {isSubmitting ? "Updating..." : "Update Order"}
        </button>
      </div>
    </form>
  );
};
